module.exports = __webpack_public_path__ + "static/media/icon_listno.80e6d1b1.svg";